import * as React from 'react';

import styled from '@emotion/styled';
import { Select } from '@lightspeed/flame/Select';

const StyledSelect = styled(Select)`
  min-width: 125px;
  max-width: 300px;
  margin-right: 1rem;
`;

type filterSelectOption = {
  name?: string;
  label?: string;
  value: number;
};

type filterData = {
  className: string;
  isCreatable: boolean;
  defaultValue?: filterSelectOption;
  defaultOptions: filterSelectOption[];
};

export const FilterSelect = ({ filterData, type }: { filterData: filterData; type: string }) => {
  const { className, defaultOptions } = filterData;
  return (
    <StyledSelect
      name={className}
      id={className}
      className={`${className} view_view`}
      defaultValue="-1"
    >
      <option value="-1">All {type}</option>
      {defaultOptions &&
        defaultOptions.map((option) => {
          return (
            <option
              key={`key-${option.value}`}
              value={option.value}
              style={{ textTransform: 'capitalize' }}
              dangerouslySetInnerHTML={{ __html: option?.label || option?.name || '' }}
            />
          );
        })}
    </StyledSelect>
  );
};
